import { RelatableVideoType } from "@/type/commonTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface YTVideoModalState {
  isOpen: boolean;
  video?: RelatableVideoType | null;
}

const initialState: YTVideoModalState = {
  isOpen: false,
  video: null,
};

const ytVideoModalSlice = createSlice({
  name: "ytVideoModal",
  initialState,
  reducers: {
    openYTVideoModal: (state) => {
      state.isOpen = true;
    },
    closeYTVideoModal: (state) => {
      state.isOpen = false;
    },
    setVideoDataYTVideoModal: (state, action: PayloadAction<RelatableVideoType | null>) => {
      state.video = action.payload;
    },
  },
});

export const { openYTVideoModal, closeYTVideoModal, setVideoDataYTVideoModal } = ytVideoModalSlice.actions;
export default ytVideoModalSlice.reducer;
